
import { Page } from '../shared/page'
import { Body } from '../shared/body'
import { Title } from './parts/title'
import { Status } from './parts/status'
import { emitter } from '../../services/emitter'
import { UploadArea } from './parts/upload-area'
import state from '../../base/services/state'
import { ProgressBar } from './parts/progress-bar'
import { Message } from './parts/message'
import { ProcessStatus } from './parts/process-status'
import { Input } from '../../base/components/native/input'
import { Base } from '../../base/components/base'
import { Div } from '../../base/components/native/div'
import { A } from '../../base/components/native/a'
import { Check } from './parts/check'
import { UploadButton } from './parts/upload-button'

export const HomePage = () => {

    const CHUNK_SIZE = 1024 * 1024 // 1MB chunks
    const WS_URL = window.location.protocol === 'https:' ? `wss://${window.location.host}` : `ws://${window.location.host}`
    let ws: WebSocket | null = null
    let selectedFile: File | null = null
    let uploadId: string | null = null

    const base = Page()

    const title = Title()
    base.append(title)

    const status = Status()
    base.append(status)

    const productName = Input('Product Name')
    productName.cssClass({ padding: '10px 30px', textAlign: 'center', fontSize: '18px', border: '1px solid #ccc', borderRadius: '5px' })
    productName.on('input', toggleUploadArea)
    base.append(productName)

    const isHiddenQuantities = Check('Hidden Quantities')
    base.append(isHiddenQuantities)

    const isExcludedFromSearch = Check('Excluded From Search')
    base.append(isExcludedFromSearch)

    const uploadArea = UploadArea()
    base.append(uploadArea)

    uploadArea.on('file-selected', handleFileSelected)

    const progressBar = ProgressBar()
    uploadArea.append(progressBar)
    progressBar.style({ display: 'none' })

    const message = Message()
    message.style({ display: 'none' })
    uploadArea.append(message)

    const processStatus = ProcessStatus()
    base.append(processStatus)

    // const body = Body()
    // body.style({ textAlign: 'center', paddingTop: '20px' })

    const erros = Base('div')
    erros.style({ marginBottom: '20px', maxHeight: '200px', overflowY: 'auto', padding: '0 10px' })
    base.append(erros)
    
    
    const reset = UploadButton('Process New File')
    reset.style({display: 'none'})
    reset.on('click', handleResetForm)
    base.append(reset)
    
    base.append(Div('V 3.1.0').style({ color: '#888', fontSize: '12px', textAlign: 'center', marginTop: '20px' }))
    state.set('uploading', false)

    function handleResetForm() {
        productName.el.disabled = false
        productName.setValue('')
        isHiddenQuantities.style({ pointerEvents: 'auto', opacity: '1' })
        isExcludedFromSearch.style({ pointerEvents: 'auto', opacity: '1' })
        isHiddenQuantities.setValue(false)
        isExcludedFromSearch.setValue(false)
        uploadArea.style({ pointerEvents: 'none', opacity: '0.5' })
        progressBar.style({ display: 'none' })
        message.style({ display: 'none' })
        processStatus.text('')
        erros.empty()
        uploadArea.reset()
        reset.style({display: 'none'})
    }
    function handleFileSelected(file: File) {
        productName.el.disabled = true
        isHiddenQuantities.style({ pointerEvents: 'none', opacity: '0.5' })
        isExcludedFromSearch.style({ pointerEvents: 'none', opacity: '0.5' })
        uploadArea.style({ pointerEvents: 'none'})
        progressBar.style({ display: 'block' })
        progressBar.setProgress(0)
        message.style({ display: 'none' })
        selectedFile = file
        if (selectedFile && !state.get('uploading')) {
            startUpload()
        }
    }

    function toggleUploadArea() {
        const productNameValue = productName.el.value.trim()
        if (productNameValue) {
            uploadArea.style({ opacity: '1', pointerEvents: 'auto' })
        } else {
            uploadArea.style({ opacity: '0.5', pointerEvents: 'none' })
        }
    }

    function connectWebSocket() {
        ws = new WebSocket(WS_URL)

        ws.onopen = () => {
            emitter.emit('ws-connected')
        }

        ws.onmessage = (event) => {
            const message = JSON.parse(event.data)
            handleServerMessage(message)
        }

        ws.onclose = () => {
            emitter.emit('ws-disconnected')
            if (state.get('uploading')) {
                showStatus('Connection lost during upload', 'error')
                resetUpload()
            }
            setTimeout(connectWebSocket, 2000)
        }

        ws.onerror = (error) => {
            console.error('WebSocket error:', error)
            showStatus('Connection error', 'error')
        }
    }

    function handleServerMessage(message: any) {
        switch (message.type) {
            case 'ready':
                startChunkedUpload()
                break

            case 'progress':
                progressBar.setProgress(message.progress)
                break

            case 'complete':
                handleUploadComplete()
                break

            case 'cancelled':
                showStatus('Upload cancelled', 'error')
                resetUpload()
                break

            case 'error':
                showStatus(`Error: ${message.message}`, 'error')
                resetUpload()
                break

            case 'processing_start':
                handleProcessingStart(message);
                break

            case 'processing_progress':
                handleProcessingProgress(message);
                break

            case 'processing_complete':
                handleProcessingComplete(message);
                break

            case 'processing_error':
                handleProcessingError(message);
                break
            case 'error_finding_attribute':
                handleAttributeError(message)
                break
        }
    }

    function startUpload() {
        if (!ws || ws.readyState !== WebSocket.OPEN) {
            showStatus('Not connected to server', 'error')
            return
        }

        uploadId = crypto.randomUUID()
        state.set('uploading', true)
        console.log({
            type: 'start',
            uploadId: uploadId,
            fileName: selectedFile?.name,
            fileSize: selectedFile?.size,
            productName: productName.el.value,
            hiddenQuantities: isHiddenQuantities.getValue(),
            excludedFromSearch: isExcludedFromSearch.getValue()
        });
        // cancelBtn.classList.add('active')
        ws!.send(JSON.stringify({
            type: 'start',
            uploadId: uploadId,
            fileName: selectedFile?.name,
            fileSize: selectedFile?.size,
            productName: productName.el.value,
            hiddenQuantities: isHiddenQuantities.getValue(),
            excludedFromSearch: isExcludedFromSearch.getValue()
        }))
    }

    async function startChunkedUpload() {
        if (!uploadId || !selectedFile) {
            showStatus('Upload cannot continue (missing upload id or file)', 'error')
            resetUpload()
            return
        }

        let offset = 0

        while (offset < selectedFile.size && state.get('uploading')) {
            const chunk = selectedFile.slice(offset, offset + CHUNK_SIZE)
            const arrayBuffer = await chunk.arrayBuffer()
            const idBuffer = new TextEncoder().encode(uploadId)
            const combinedBuffer = new Uint8Array(idBuffer.length + arrayBuffer.byteLength)
            combinedBuffer.set(idBuffer, 0)
            combinedBuffer.set(new Uint8Array(arrayBuffer), idBuffer.length)

            if (ws!.readyState === WebSocket.OPEN) {
                ws!.send(combinedBuffer)
            } else {
                showStatus('Connection lost', 'error')
                resetUpload()
                break
            }

            offset += CHUNK_SIZE
            // Small delay to prevent overwhelming the server
            await new Promise(resolve => setTimeout(resolve, 10))
        }

        if (state.get('uploading') && ws!.readyState === WebSocket.OPEN) {
            ws!.send(JSON.stringify({
                type: 'complete',
                uploadId: uploadId
            }))
        }
    }

    function handleUploadComplete() {
        showStatus('✅ Upload complete!', 'success')
        progressBar.setProgress(100)
        resetUpload()
    }

    function resetUpload() {
        state.set('uploading', false)
        uploadId = null
        // uploadBtn.disabled = false
        // cancelBtn.classList.remove('active')
    }

    function showStatus(m: string, type: string) {
        // todo: handle error
        if (type === 'success') {
            setTimeout(() => {
                message.style({ display: 'flex' })
                progressBar.style({ display: 'none' })
            }, 1000);
        }
    }

    // Cancel button handler
    // cancelBtn.addEventListener('click', () => {
    //     if (isUploading) {
    //         cancelUpload()
    //     }
    // })

    function cancelUpload() {
        if (state.get('uploading') && ws!.readyState === WebSocket.OPEN) {
            ws!.send(JSON.stringify({
                type: 'cancel',
                uploadId: uploadId
            }))
        }
        state.set('uploading', false)
    }

    function handleProcessingStart(message: any) {
        processStatus.text(message.message);
    }

    function handleProcessingProgress(message: any) {
        processStatus.text(`Processing row: ${message.row}`);
    }

    function handleProcessingComplete(message: any) {

        processStatus.text(`Complete! Processed ${message.totalRows} rows in ${message.processingTime}s`);
        reset.style({display: 'block'})
        if (message.downloadLink) {
            const downloadEntry = A(message.downloadLink, 'Download processed files (ZIP)', '_blank')
            downloadEntry.el.setAttribute('download', '');
            downloadEntry.el.className = 'processing-log-entry success';
            // downloadEntry.innerHTML = `<a href="${message.downloadLink}" target="_blank" style="color: #155724; font-weight: bold;">Download processed files (ZIP)</a>`;
            // downloadEntry.onclick = (e) => {
            //     e.preventDefault();
            //     window.location.href = message.downloadLink;
            // };
            processStatus.append(downloadEntry);
        }
    }

    function handleAttributeError(message: any) {
        erros.append(Div(message.message).style({ color: 'red', fontWeight: 'bold', margin: '10px auto' }))
    }
    function handleProcessingError(message: any) {
        processStatus.text('❌ Processing failed');
    }

    connectWebSocket()

    return base
}